import React, { useEffect, useState } from "react";
import { getOrderListAPI } from "../../../service/cart.service";
import SpinnerComponent from "../../atoms/spinner/spinner.component";
import { FiCalendar, FiCreditCard, FiEye, FiPackage } from "react-icons/fi";
import "./my-orders.component.css";
import { useNavigate } from "react-router-dom";

const MyOrderComponent = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState({
    loading: true,
    data: [],
    showData: false,
  });
  const onLoad = async () => {
    setOrders({ ...orders, loading: true, showData: false });
    const orderResp = await getOrderListAPI();
    console.log({ orderResp });
    if (orderResp.status) {
      setOrders({
        ...orders,
        data: orderResp.data,
        loading: false,
        showData: true,
      });
    }
  };

  useEffect(() => {
    onLoad();
  }, []);
  console.log({ orders });

  const handleViewDetails = (order) => {
    console.log("handleViewDetails", order);
    navigate(`/account/order-details/${order.order_id}`, {
      state: { id: order.id },
    });
  };
  // console.log({ orders });
  const getStatusClass = (status) => {
    if (!status) return "status-pending";
    const statusLower = status.toLowerCase();
    if (statusLower.includes("delivered")) return "status-delivered";
    if (statusLower.includes("shipped") || statusLower.includes("processing"))
      return "status-shipped";
    if (statusLower.includes("cancel")) return "status-cancelled";
    return "status-pending";
  };

  const getPaymentStatusClass = (status) => {
    if (!status) return "text-danger";
    const statusLower = status.trim().toLowerCase();
    return statusLower === "paid" || statusLower.includes("complete")
      ? "text-success"
      : "text-danger";
  };

  return (
    <div className="orders-container">
      <div className="orders-header">
        <h2>My Orders</h2>
      </div>

      {orders.loading ? (
        <div className="loading-container">
          <SpinnerComponent />
        </div>
      ) : orders.showData && orders.data.length > 0 ? (
        <div className="table-responsive">
          <table className="orders-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Date</th>
                <th>Items</th>
                <th>Total</th>
                <th>Status</th>
                <th>Payment</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders?.data?.map((order, index) => (
                <tr key={index} className="order-row">
                  <td className="order-id">#{order.order_id}</td>
                  <td>
                    <FiCalendar /> {order.date || "N/A"}
                  </td>
                  <td className="order-count">
                    {order.product_count || 0} items
                  </td>
                  <td className="order-total">
                    {order.order_value ? `₹${order.order_value}` : "₹0.00"}
                  </td>
                  <td>
                    <span
                      className={`status-badge ${getStatusClass(order.status)}`}
                    >
                      {order.status || "Processing"}
                    </span>
                  </td>
                  <td>
                    <span
                      className={`payment-status ${getPaymentStatusClass(
                        order.payment_status
                      )}`}
                    >
                      <FiCreditCard className="icon" />
                      {order.payment_status || "Pending"}
                    </span>
                  </td>
                  <td className="order-actions">
                    <button
                      className="view-details-btn"
                      onClick={() => handleViewDetails(order)}
                    >
                      <FiEye className="icon" /> View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="no-orders">
          <FiPackage className="empty-icon" />
          <h3>No Orders Found</h3>
          <p>You haven't placed any orders yet.</p>
          <button className="continue-shopping-btn">Continue Shopping</button>
        </div>
      )}
    </div>
  );
};

export default MyOrderComponent;
